import urlBuilder from "@Utils/urlBuilder";
import themeVariables from "@Theme/exportColor.module.scss";
import currencyData from "constants/currencyConstants";

export const tagStylesMap = {
  "University Provided": {
    background: "linear-gradient(91deg, #0C0E11 22.16%, rgba(12, 14, 17, 0.70) 97.53%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: "#FAC85C",
  },
  "UAL Hall": {
    background: "linear-gradient(91deg, #0C0E11 22.16%, rgba(12, 14, 17, 0.70) 97.53%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: "#FAC85C",
  },
  "Top Rated": {
    background: "linear-gradient(94deg, #F6FFFB 49.13%, #E1F5EC 99.06%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: themeVariables.secondary5,
  },
  // The rail badge the "Based on your <city> search" tier assigns to recently-viewed cards.
  // Shares the Top Rated palette deliberately — it is a neutral "you have seen this" marker,
  // not a promotional claim, and iOS renders it with the same gradient.
  "Recently Seen": {
    background: "linear-gradient(94deg, #F6FFFB 49.13%, #E1F5EC 99.06%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: themeVariables.secondary5,
  },
  "Filling Fast": {
    background: "linear-gradient(273deg, #E3F1FE 1.48%, #F4F9FF 55.27%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: themeVariables.info6,
  },
  "FLASH SALE": {
    background: "linear-gradient(273deg, #E3F1FE 1.48%, #F4F9FF 55.27%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: themeVariables.info6,
  },
  "Cashback/Discount": {
    background: "linear-gradient(92deg, #FFF7F9 42.58%, #FBE6EB 100%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: themeVariables.primary5,
  },
  "Property of the Day": {
    background: "linear-gradient(91deg, #0C0E11 22.16%, rgba(12, 14, 17, 0.70) 97.53%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: "#FAC85C",
  },
  "Amber Exclusive": {
    background: " linear-gradient(92deg, #FFF8F2 43.06%, #FFECDC 100%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: "#E68257",
  },
  "Student's Choice": {
    background: "linear-gradient(92deg, #FEF2FF 43.06%, #FDCCFF 100%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: "#A307A8",
  },
  "Immediate Move-In": {
    background: "linear-gradient(92deg, #FDFEF9 17%, #ECF8C3 78%, #E0F39C 100%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: "#7FA106",
  },
  "Breakfast Included": {
    background: "linear-gradient(92deg, #FFF2FF 50.18%, #FDD3E9 97.65%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: "#F7008B",
  },
  "On Campus": {
    background: "linear-gradient(92deg, #FFF2FF 50.18%, #FDD3E9 97.65%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: "#F7008B",
  },
  "Off Campus": {
    background: "linear-gradient(92deg, #FEF2FF 43.06%, #FDCCFF 100%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: "#A307A8",
  },
};

const getLocation = (
  locationObject: any,
  includeOptions = ["locality_long_name", "state_long_name", "country_short_name"],
) => {
  let location = null;
  const location_arr = [];
  if (includeOptions.includes("street_number") && locationObject?.street_number?.long_name) {
    location_arr.push(locationObject.street_number.long_name);
  }
  if (includeOptions.includes("route_long_name") && locationObject?.route?.long_name) {
    location_arr.push(locationObject.route.long_name);
  }
  if (includeOptions.includes("route_short_name") && locationObject?.route?.short_name) {
    location_arr.push(locationObject.route.short_name);
  }
  if (
    includeOptions.includes("locality_short_name") &&
    (locationObject?.locality?.short_name || locationObject?.district?.short_name)
  ) {
    location_arr.push(locationObject?.locality?.short_name || locationObject?.district?.short_name);
  }
  if (
    includeOptions.includes("locality_long_name") &&
    (locationObject?.locality?.long_name || locationObject?.district?.long_name)
  ) {
    location_arr.push(locationObject?.locality?.long_name || locationObject?.district?.long_name);
  }
  if (includeOptions.includes("postal_code") && locationObject?.postal_code?.long_name) {
    location_arr.push(locationObject.postal_code.long_name);
  }
  if (locationObject?.state?.short_name && includeOptions.includes("state_short_name")) {
    location_arr.push(locationObject.state.short_name);
  }
  if (includeOptions.includes("state_long_name") && locationObject?.state?.long_name) {
    location_arr.push(locationObject.state.long_name);
  }
  if (includeOptions.includes("country_short_name") && locationObject?.country?.short_name) {
    location_arr.push(locationObject.country.short_name);
  }
  if (includeOptions.includes("country_long_name") && locationObject?.country?.long_name) {
    location_arr.push(locationObject.country.long_name);
  }
  if (location_arr.length > 0) {
    location = location_arr.join(", ");
  }
  return location;
};

export const isAvailable = (data: any) => {
  let flag = true;
  // Either if tag is mentioned
  if (data?.tags) {
    data.tags?.forEach((tag: any) => {
      if (tag == "not_available") {
        flag = false;
      }
    });
  }
  // if inventory is not available
  if (data?.available === false) {
    flag = false;
  }

  // Otherwise if its inactive (only for parent)
  if (data?.parent_id == null && data?.status == "inactive") {
    flag = false;
  }
  return flag;
};

export const getDistanceData = (data: any) => {
  if (data) {
    const i = 0;
    const walking = data[i][3];
    const driving = data[i + 1][3];
    const transit = data[i + 2][3];
    const distance: any = {};
    if (walking && walking.data.status === "OK") {
      distance.WALKING = {
        distance: walking.data.distance?.text,
        duration: walking.data?.duration?.text,
      };
    } else
      distance.WALKING = {
        distance: "0 ft",
        duration: "0 min",
      };

    if (driving && driving.data.status === "OK")
      distance.DRIVING = {
        distance: driving.data.distance?.text,
        duration: driving.data?.duration?.text,
      };
    else
      distance.DRIVING = {
        distance: "0 ft",
        duration: "0 min",
      };
    if (transit && transit.data.status === "OK")
      distance.TRANSIT = {
        distance: transit.data.distance?.text,
        duration: transit.data?.duration?.text,
      };
    else
      distance.TRANSIT = {
        distance: "0 ft",
        duration: "0 min",
      };
    return distance;
  }
  return null;
};

/**
 * Canonical name of the recently-seen rail badge.
 *
 * It is an identifier, not copy: `tagStylesMap` and `propertyTagNames` are keyed on it, and
 * `PropertyTags` translates it at render through the `"Recently Seen"` entry in
 * `translations.json`. Exported so the rail that assigns it does not repeat the literal.
 */
export const RECENTLY_SEEN_TAG = "Recently Seen";

export const propertyTagNames = [
  "University Provided",
  "UAL Hall",
  "Top Rated",
  "Recently Seen",
  "Filling Fast",
  "FLASH SALE",
  "Cashback/Discount",
  "Property of the Day",
  "Amber Exclusive",
  "Student's Choice",
  "Immediate Move-In",
  "Breakfast Included",
  "On Campus",
  "Off Campus",
] as const;

type GetPropertyCardTagNameReturnType = (typeof propertyTagNames)[number] | string | null;

export const getPropertyCardTagName = ({
  isTopRated = false,
  isFillingFast = false,
  isFillingFastV2 = false,
  isCashbackOrDiscount = false,
  cashbackValue = "",
  isPropertyOfTheDay = false,
  isAmberExclusive = false,
  isStudentChoice = false,
  isImmediateMoveIn = false,
  isBreakfastIncluded = false,
  isOnCampusInventory = false,
  isOffCampusInventory = false,
  isUniversityProvided = false,
  isUalHall = false,
  t = (val: string) => val,
} = {}): GetPropertyCardTagNameReturnType => {
  if (isUalHall) return "UAL Hall";
  if (isUniversityProvided) return "University Provided";
  if (isPropertyOfTheDay) return t("searchpage.components.selectlistitem.propertyoftheday");
  if (isFillingFastV2) return t("searchpage.components.selectlistitem.fillingfast");
  if (isAmberExclusive) return t("searchpage.components.selectlistitem.amberexclusive");
  if (isStudentChoice) return t("searchpage.components.selectlistitem.studentchoice");
  if (isFillingFast) return t("searchpage.components.selectlistitem.fillingfast");
  if (isImmediateMoveIn) return t("searchpage.components.selectlistitem.immediatemovein");
  if (isBreakfastIncluded) return t("searchpage.components.selectlistitem.breakfastincluded");
  if (isOnCampusInventory) return t("searchpage.components.selectlistitem.oncampus");
  if (isOffCampusInventory) return t("searchpage.components.selectlistitem.offcampus");
  if (isCashbackOrDiscount) {
    return cashbackValue
      ? `${t("searchpage.components.selectlistitem.saveupto")} ${cashbackValue}`
      : null;
  }
  if (isTopRated) return t("searchpage.components.selectlistitem.toprated");
  return null;
};

export const getPricingRangeFromRegion = (regionObject: any) => {
  let range = [];
  range = [0, 1000];
  // UK
  if (regionObject?.combined_name?.includes("United Kingdom")) {
    range = [0, 1000];
  }
  // USA
  if (regionObject?.combined_name?.includes("United States")) {
    range = [0, 5000];
  }
  // Canada
  if (regionObject?.combined_name?.includes("Canada")) {
    range = [0, 5000];
  }
  // Australia
  if (regionObject?.combined_name?.includes("Australia")) {
    range = [0, 1000];
  }
  return range;
};

export const getAvailableStartingPricing = (pricingObject: any) => {
  const price = getAvailableStartingPricingHelper(pricingObject);
  const currency = getPricingCurrency(pricingObject?.currency) ?? "";
  return price ? currency + price : null;
};

export const getAvailableStartingPricingHelper = (pricingObject: any) =>
  pricingObject?.min_available_price ||
  pricingObject?.max_available_price ||
  pricingObject?.available_price ||
  pricingObject?.min_price ||
  pricingObject?.max_price ||
  pricingObject?.price;

export const getPricingCurrency = (currency: any) => {
  const finalCurrencyObject = currencyData.find(
    (currencyObject) =>
      currencyObject?.short_name?.toLocaleLowerCase() === currency?.toLocaleLowerCase() ||
      currencyObject?.standard_name?.toLocaleLowerCase() === currency?.toLocaleLowerCase(),
  );
  if (finalCurrencyObject) {
    return finalCurrencyObject.symbol;
  }
  return "£";
};

export const getPricingDuration = (duration: any) => {
  let durationFormatted = null;
  switch (duration) {
    case "weekly":
      durationFormatted = "week";
      break;
    case "monthly":
      durationFormatted = "month";
      break;
    default:
      durationFormatted = "";
  }
  return durationFormatted;
};

export const getChildrenCount = (data: any) => {
  let childrenCount = 0;
  if (data?.active_children_count) {
    childrenCount = data.active_children_count;
  }

  if (data && "active_children_with_filters_count" in data) {
    childrenCount = data.active_children_with_filters_count;
  }

  // if (childrenCount === 0) return null;
  return childrenCount;
};

export type PluralizeArgs = {
  noun: string;
  count?: number;
  suffix?: string;
};

export const isPaymentActive = (inventory: any, isBookFormEnabledForInactiveProperty = false) => {
  let flag = isAvailable(inventory) || isBookFormEnabledForInactiveProperty;
  if (inventory?.meta?.payment == false) {
    flag = false;
  }
  return flag;
};

export const pluralize = ({ noun, count = 0, suffix = "s" }: PluralizeArgs) =>
  count > 1 ? `${noun}${suffix}` : noun;

export const pluralizeWithCount = ({ noun, count = 0, suffix = "s" }: PluralizeArgs) =>
  `${count} ${pluralize({ noun, count, suffix })}`;

const isPropertyCardTagName = (tagName: any): tagName is (typeof propertyTagNames)[number] =>
  propertyTagNames.includes(tagName);

export const getPropertyCardTagStyles = (tagName: GetPropertyCardTagNameReturnType) => {
  if (isPropertyCardTagName(tagName)) {
    return tagStylesMap[tagName];
  }
  return {
    background: "linear-gradient(92deg, #FFF7F9 42.58%, #FBE6EB 100%)",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
    color: "#f3123c",
  };
};

export const getPropertyFilter = (params = {}) => {
  const obj = {};
  if (typeof window === "undefined") return obj;
  let urlParams = new URLSearchParams(window.location.search);
  if (params && Object.keys(params).length > 0) {
    urlParams = new URLSearchParams(params);
  }
  const paramsForProperty = [
    "range_available_price",
    "move_in_month",
    "meta_min_lease_duration",
    "meta_max_lease_duration",
    "meta_types",
    "tags",
    "partner_id",
  ];
  paramsForProperty.forEach((key) => {
    const value = urlParams.get(key);
    if (value) {
      // @ts-ignore
      obj[key] = value;
    }
  });
  return obj;
};

export const getLink = (data: any, params = {}) => {
  let url = null;
  if (data?.canonical_name) {
    const paths = [];
    paths.push("/places");
    paths.push(data.canonical_name);

    // add url options
    const url_options: any = {};
    url_options.path = paths;
    url_options.params = params;

    // Build link
    url = urlBuilder(url_options.path, { params: url_options.params });
  }
  return url;
};

export default getLocation;

/**
 * Computes an effective rating using meta.review_summary.overall_rating as fallback
 * when reviews_rating is 0/null/undefined.
 */
export const getEffectiveRating = (reviewsRating: any, meta?: any): string => {
  if (reviewsRating && parseFloat(String(reviewsRating)) > 0) {
    return String(reviewsRating);
  }
  const overallRating = meta?.review_summary?.overall_rating;
  if (overallRating && parseFloat(String(overallRating)) > 0) {
    return String(overallRating);
  }
  return "0";
};
